module.exports = __webpack_public_path__ + "static/img/a09.4b818725.jpg";